import Index from "../index";
import request from "@/common/request";
import { INewsDetails, IConmmen } from "./types.d";
import { IResponse } from "../types";
class IndexRequest extends Index {
  /**
   * 获取留言
   * @param sourceId 源ID
   * @param lastCreateTime 最后一条记录的创建时间
   * @param lastReplyId 最后一条记录的评论ID
   */
  getComment(
    appId: string,
    sessionId: string,
    token: string,
    sourceType: string | number,
    sourceId: number,
    lastCreateTime: string,
    lastReplyId?: number
  ): Promise<IConmmen> {
    return request.post(process.env.VUE_APP_BASEGATE_API + "/comments", {
      appId,
      sessionId,
      token,
      sourceType,
      sourceId: sourceId,
      lastCreateTime: lastCreateTime,
      lastReplyId: lastReplyId
    });
  }
}

export default IndexRequest;
